import { X, CheckCircle2 } from 'lucide-react';

const BidsModal = ({ bids, onClose, onAccept }) => (
  <div className="mjobs-modal-overlay" onClick={onClose}>
    <div className="mjobs-bids-modal" onClick={e => e.stopPropagation()}>

      <div className="mjobs-bids-modal__header">
        <h4 className="mjobs-bids-modal__title">Received Bids</h4>
        <span className="mjobs-bids-modal__count">{bids.length} bid{bids.length !== 1 ? 's' : ''}</span>
        <button className="mjobs-bids-modal__close" onClick={onClose}><X size={16} /></button>
      </div>

      <div className="mjobs-bids-modal__list">
        {bids.length === 0 ? (
          <div className="mjobs-bids-modal__empty">No bids received yet.</div>
        ) : bids.map((wb) => (
          <div key={wb.id} className="mjobs-bids-modal__item">
            <div className="mjobs-bids-modal__worker">
              <div className="mjobs-bids-modal__avatar">
                {(wb.whserviceprovider?.fullName || 'W').charAt(0).toUpperCase()}
              </div>
              <div className="mjobs-bids-modal__worker-info">
                <span className="mjobs-bids-modal__worker-name">
                  {wb.whserviceprovider?.fullName || 'Worker'}
                </span>
                {wb.message && (
                  <span className="mjobs-bids-modal__message">"{wb.message}"</span>
                )}
              </div>
            </div>
            <div className="mjobs-bids-modal__right">
              <span className="mjobs-bids-modal__amount">$ {wb.bidAmount?.toLocaleString()}</span>
              <button
                className="mjobs-bids-modal__accept-btn"
                onClick={() => onAccept(wb.id)}
              >
                <CheckCircle2 size={13} /> Accept
              </button>
            </div>
          </div>
        ))}
      </div>

    </div>
  </div>
);

export default BidsModal;